module.exports = __webpack_public_path__ + "img/swap-horizontal.a11c3836.svg";